import style from './style.module.scss'
import { useState } from 'react'
import PhoneIphoneRoundedIcon from '@mui/icons-material/PhoneIphoneRounded'
import LaptopMacRoundedIcon from '@mui/icons-material/LaptopMacRounded'
import ReplayRoundedIcon from '@mui/icons-material/ReplayRounded'
import { ISurvey } from 'src/utils/Interfaces/survey.interface'

const BASE_URL = import.meta.env.VITE_BASE_URL

const SurveyPreview = ({ survey }: { survey: ISurvey }) => {
  const [device, setDevice] = useState('desktop')
  const handleIframeType = (e: React.MouseEvent<SVGElement>) => {
    const type = e.currentTarget.getAttribute('data-type')
    if (type) {
      setDevice(type)
    }
  }

  const reloadIframe = () => {
    const iframe = document.querySelector('#preview_survey') as HTMLIFrameElement | null
    if (iframe) {
      // eslint-disable-next-line no-self-assign
      iframe.src = iframe.src
    }
  }
  return (
    <div className={style.preview + ' block'} data-device={device}>
      <div className={style.switcher}>
        <ReplayRoundedIcon onClick={reloadIframe} className="reload" />
        <PhoneIphoneRoundedIcon onClick={handleIframeType} data-type="mobile" className={device === 'mobile' ? 'active' : ''} />
        <LaptopMacRoundedIcon onClick={handleIframeType} data-type="desktop" className={device === 'desktop' ? 'active' : ''} />
      </div>
      {survey.clientId && (
        <iframe
          style={{ border: 'none' }}
          id="preview_survey"
          src={BASE_URL + `/preview-survey/${survey.id}?client=` + survey.clientId || ''}
        ></iframe>
      )}
    </div>
  )
}

export default SurveyPreview
